import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealskanbanRoutingModule } from './dealskanban-routing.module';
import { DealskanbanComponent } from './dealskanban.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { IconModule } from '@visurel/iconify-angular';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { CrmdealskanbanRoutingModule } from '../crmdealskanban/crmdealskanban-routing.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [
    DealskanbanComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    DealskanbanRoutingModule,
    CustomFlexLayoutModule,
    MatCardModule,
    DragDropModule,
  SharedModule,
  PipesModule,
    CrmdealskanbanRoutingModule,
    IconModule,
    NgxMatSelectSearchModule
  ],
  exports:[
    DealskanbanComponent
  ]
})
export class DealskanbanModule { }
